import type { ReactNode } from 'react'

/**
 * EmptyState — centred empty / no-results block for tables.
 * Renders its own icon, title, optional description and optional action.
 */
interface EmptyStateProps {
  dark: boolean
  title: string
  description?: string
  /** Optional action — e.g. "Clear filters" button */
  action?: ReactNode
}

const IconInbox = () => (
  <svg
    className="w-8 h-8 mb-3 opacity-30"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 12h-6l-2 3H10l-2-3H2" />
    <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z" />
  </svg>
)

export function EmptyState({ dark, title, description, action }: EmptyStateProps) {
  const mainTxt  = dark ? 'text-slate-100' : 'text-slate-900'
  const mutedTxt = dark ? 'text-slate-500' : 'text-slate-500'

  return (
    <div className="flex flex-col items-center justify-center py-14 px-6 text-center">
      <div className={mutedTxt}>
        <IconInbox />
      </div>
      <div className={`text-[13px] font-semibold ${mainTxt}`}>{title}</div>
      {description && (
        <div className={`text-[11px] mt-1 ${mutedTxt}`}>{description}</div>
      )}
      {action && (
        <div className="mt-4">{action}</div>
      )}
    </div>
  )
}
